/* Product UI only. Basket ownership stays with window.SniezkowoCart. */
(() => {
  'use strict';
  const validColors = {fondue:['brown','white','red','trio'],train:['black']};
  const labels={brown:'Brązowy',white:'Biały',red:'Czerwony',trio:'Trio — 3 kolory',black:'Czarny'};
  function parseQuantity(raw) {
    if (!/^\d+$/.test(String(raw))) return null;
    const quantity=Number(raw);
    return Number.isSafeInteger(quantity)&&quantity>=1&&quantity<=10 ? quantity : null;
  }
  function quote({key,color,gift=false,quantity},catalog=globalThis.SNIEZKOWO_PRODUCTS) {
    const qty=parseQuantity(quantity);
    if(qty===null)return {ok:false,error:'Wpisz całkowitą ilość od 1 do 10.'};
    const variant=catalog?.[key]?.colors?.[color];
    if(!variant||typeof gift!=='boolean')return {ok:false,error:'Ten wariant jest niedostępny.'};
    const id=gift?variant.giftVariantId:variant.variantId;
    const available=gift?variant.giftAvailable:variant.available;
    const selectedPrice=gift?variant.giftPrice:variant.price;
    if(!/^\d+$/.test(String(id||''))||available!==true||!Number.isSafeInteger(selectedPrice)||selectedPrice<0)return {ok:false,error:'Ten wariant jest niedostępny.'};
    const units=key==='fondue'&&color==='trio'?3:1;
    const basePrice=Number.isSafeInteger(variant.price)?variant.price:selectedPrice;
    return {ok:true,quantity:qty,unitCents:basePrice,giftUnitCents:gift?selectedPrice-basePrice:0,totalCents:selectedPrice*qty,physicalUnits:units*qty,variantId:String(id)};
  }

  if(typeof module==='object'&&module.exports) module.exports={parseQuantity,quote};
  if(typeof document==='undefined') return;
  const root=document.querySelector('.pdp-main');
  const form=root?.querySelector('[data-buy-form]');
  if(!root||!form) return;
  const key=form.dataset.productKey;
  const quantity=form.querySelector('[data-quantity]');
  const gift=form.querySelector('[data-gift]');
  const kindInputs=[...form.querySelectorAll('input[name="kind"]')];
  const colorInputs=[...form.querySelectorAll('input[name="color"]')];
  const colors=form.querySelector('[data-colors]');
  const colorName=form.querySelector('[data-color-name]');
  const total=form.querySelector('[data-total]');
  const giftCost=form.querySelector('[data-gift-cost]');
  const error=form.querySelector('[data-form-error]');
  const status=form.querySelector('[data-form-status]');
  const add=form.querySelector('[data-add]');
  const minus=form.querySelector('[data-qty-minus]');
  const plus=form.querySelector('[data-qty-plus]');
  const sticky=document.querySelector('[data-sticky]');
  const stickySummary=sticky?.querySelector('[data-sticky-summary]');
  const money=cents=>new Intl.NumberFormat('pl-PL',{style:'currency',currency:window.SNIEZKOWO_CURRENCY}).format(cents/100);
  let color=key==='fondue'?'brown':'black',lastSingle='brown',busy=false;
  const params=new URL(window.location.href).searchParams;const queryColor=params.get('color');const requestedId=params.get('variant');
  const requestedQuantity=parseQuantity(params.get('quantity'));if(requestedQuantity!==null)quantity.value=String(requestedQuantity);
  if(requestedId){for(const [candidate,v] of Object.entries(window.SNIEZKOWO_PRODUCTS?.[key]?.colors||{})){if(String(v.variantId)===requestedId||String(v.giftVariantId)===requestedId){color=candidate;lastSingle=candidate==='trio'?'brown':candidate;if(gift)gift.checked=String(v.giftVariantId)===requestedId;}}}
  if(validColors[key]?.includes(queryColor)){color=queryColor;if(color!=='trio')lastSingle=color;}

  const gallery=root.querySelector('[data-gallery]');
  const main=gallery.querySelector('[data-main-image]');
  const thumbs=[...gallery.querySelectorAll('[data-photo-key]')];
  const indexLabel=gallery.querySelector('[data-photo-index]');
  const caption=gallery.querySelector('p[data-photo-caption]');
  const zoom=document.querySelector('[data-zoom]');
  const zoomImage=zoom.querySelector('[data-zoom-image]');
  const zoomCaption=zoom.querySelector('[data-zoom-caption]');
  const zoomClose=zoom.querySelector('[data-zoom-close]');
  let photoIndex=0,zoomOpener=null;
  function syncZoom(){zoomImage.src=main.currentSrc||main.src;zoomImage.alt=main.alt;zoomImage.width=main.width;zoomImage.height=main.height;zoomCaption.textContent=caption.textContent;}
  function choosePhoto(index){
    photoIndex=(index+thumbs.length)%thumbs.length;
    const selected=thumbs[photoIndex];
    main.removeAttribute('srcset');main.removeAttribute('sizes');
    main.src=selected.dataset.photoSrc;main.alt=selected.dataset.photoAlt;
    main.width=Number(selected.dataset.photoWidth);main.height=Number(selected.dataset.photoHeight);
    main.style.objectFit=selected.dataset.photoFit||'contain';
    caption.textContent=selected.dataset.photoCaption||selected.dataset.photoAlt;
    indexLabel.textContent=`${photoIndex+1} / ${thumbs.length}`;
    thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===photoIndex)));
    const strip=selected.parentElement;
    if(strip.scrollWidth>strip.clientWidth){
      const stripBounds=strip.getBoundingClientRect(),bounds=selected.getBoundingClientRect();
      strip.scrollLeft+=bounds.left-stripBounds.left-(strip.clientWidth-bounds.width)/2;
    }
    if(zoom.open)syncZoom();
  }
  thumbs.forEach((t,i)=>t.addEventListener('click',()=>choosePhoto(i)));
  gallery.querySelector('[data-photo-prev]').addEventListener('click',()=>choosePhoto(photoIndex-1));
  gallery.querySelector('[data-photo-next]').addEventListener('click',()=>choosePhoto(photoIndex+1));
  function galleryKeyboard(event){if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();choosePhoto(photoIndex+(event.key==='ArrowRight'?1:-1));}}
  gallery.addEventListener('keydown',galleryKeyboard);zoom.addEventListener('keydown',galleryKeyboard);
  gallery.querySelector('[data-zoom-open]').addEventListener('click',event=>{zoomOpener=event.currentTarget;syncZoom();zoom.showModal();zoomClose.focus();});
  zoomClose.addEventListener('click',()=>zoom.close());
  zoom.addEventListener('click',event=>{const r=zoom.getBoundingClientRect();if(event.target===zoom&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))zoom.close();});
  zoom.addEventListener('close',()=>{if(zoomOpener?.isConnected)zoomOpener.focus({preventScroll:true});});

  function currentQuote(){return quote({key,color,gift:gift?.checked||false,quantity:quantity.value});}
  function update({showError=true,selectImage=false,preserveError=false}={}){
    const result=currentQuote();
    const trio=color==='trio';
    kindInputs.forEach(input=>{input.checked=input.value===(trio?'trio':'single');});
    colorInputs.forEach(input=>{const entry=window.SNIEZKOWO_PRODUCTS?.[key]?.colors?.[input.value];input.checked=input.value===lastSingle;input.disabled=trio||(!entry?.available&&!entry?.giftAvailable);});
    if(colors)colors.hidden=trio;
    if(colorName)colorName.textContent=labels[lastSingle];
    const mapped=window.SNIEZKOWO_PRODUCTS?.[key]?.colors?.[color];
    if(giftCost)giftCost.textContent=mapped?.giftAvailable&&Number.isSafeInteger(mapped.giftPrice)&&Number.isSafeInteger(mapped.price)?'+ '+money(mapped.giftPrice-mapped.price):'Niedostępne';
    if(gift)gift.disabled=busy||(!mapped?.giftAvailable&&!gift.checked);
    const nativeId=form.querySelector('[data-native-variant-id]');if(nativeId)nativeId.value=result.ok?result.variantId:'';
    const label=form.querySelector('[data-unit-label]');
    if(label)label.textContent=key==='train'?'sztuk':trio?'zestawów Trio':'kubków';
    if(result.ok){
      quantity.setAttribute('aria-invalid','false');if(!preserveError)error.textContent='';total.textContent=money(result.totalCents);
      const units=result.physicalUnits;
      form.querySelector('[data-quantity-description]').textContent=key==='train'?`${result.quantity} × lokomotywa`:`${units} ${units===1?'kubek':'kubków'} · ${units} ${units===1?'widelczyk':'widelczyków'}`;
      if(stickySummary)stickySummary.textContent=`${labels[color]} · ${money(result.totalCents)}`;
      minus.disabled=busy||result.quantity===1;plus.disabled=busy||result.quantity===10;
    }else{
      quantity.setAttribute('aria-invalid','true');total.textContent='—';
      if(showError)error.textContent=result.error;
      form.querySelector('[data-quantity-description]').textContent='Wpisz ilość od 1 do 10.';
      if(stickySummary)stickySummary.textContent='Sprawdź ilość';
      minus.disabled=busy;plus.disabled=busy;
    }
    add.disabled=busy||!result.ok;
    if(selectImage){const i=thumbs.findIndex(t=>t.dataset.photoKey===color);if(i>=0)choosePhoto(i);}
    window.SniezkowoPromotion?.update(form);
    return result;
  }
  function variantChanged(){status.textContent='';update({selectImage:true});const url=new URL(location.href);url.searchParams.set('color',color);const result=currentQuote();if(result.ok)url.searchParams.set('variant',result.variantId);else url.searchParams.delete('variant');history.replaceState(null,'',url);}
  kindInputs.forEach(input=>input.addEventListener('change',()=>{color=input.value==='trio'?'trio':lastSingle;variantChanged();}));
  colorInputs.forEach(input=>input.addEventListener('change',()=>{color=input.value;lastSingle=color;variantChanged();}));
  quantity.addEventListener('input',()=>{status.textContent='';update();});
  gift?.addEventListener('change',()=>{status.textContent='';update();});
  function step(amount){const q=parseQuantity(quantity.value);if(q===null){update();quantity.focus();return;}const next=q+amount;if(next<1||next>10)return;quantity.value=String(next);status.textContent='';update();}
  minus.addEventListener('click',()=>step(-1));plus.addEventListener('click',()=>step(1));
  form.addEventListener('submit',async event=>{
    event.preventDefault();if(busy)return;
    const result=update();if(!result.ok){quantity.focus();return;}
    const payload={key,color,gift:gift?.checked||false,quantity:result.quantity};
    busy=true;form.setAttribute('aria-busy','true');status.textContent='Dodajemy do koszyka…';update();
    let added=false;
    try{
      if(!window.SniezkowoCart||typeof window.SniezkowoCart.add!=='function')throw new Error('Koszyk nie jest dostępny. Odśwież stronę i spróbuj ponownie.');
      const response=await window.SniezkowoCart.add(payload);
      if(!response?.ok)throw new Error(response?.error||'Nie udało się dodać produktu. Spróbuj ponownie.');
      added=true;status.textContent='Produkt dodany do koszyka.';
      if(typeof window.SniezkowoCart.open==='function')await window.SniezkowoCart.open();
    }catch(e){
      if(added)status.textContent='Produkt dodano. Otwórz koszyk u góry strony, aby sprawdzić wybór.';
      else{status.textContent='';error.textContent=e.message||'Nie udało się dodać produktu.';}
    }finally{busy=false;form.removeAttribute('aria-busy');update({showError:false,preserveError:true});}
  });
  // Only appears after the purchase form was passed; it never covers its controls.
  const purchase=document.getElementById('buy');
  function updateSticky(){if(sticky)sticky.hidden=!(purchase.getBoundingClientRect().bottom<0);}
  window.addEventListener('scroll',updateSticky,{passive:true});window.addEventListener('resize',updateSticky);
  const observer=new IntersectionObserver(updateSticky);observer.observe(purchase);
  update({showError:false,selectImage:true});updateSticky();
})();
